export const LightsTypes = {
  AMBIENT_LIGHT: 'AmbientLight',
  DIRECTIONAL_LIGHT: 'DirectionalLight',
  POINT_LIGHT: 'PointLight',
  SPOT_LIGHT: 'SpotLight'
};

export const LightsTypesHelper = {
  AMBIENT_LIGHT: 'AmbientLightHelper',
  DIRECTIONAL_LIGHT: 'DirectionalLightHelper',
  POINT_LIGHT: 'PointLightHelper',
  SPOT_LIGHT: 'SpotLightHelper'
};
